"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _getIterator = require("@babel/runtime-corejs3/core-js/get-iterator");

var _Array$isArray2 = require("@babel/runtime-corejs3/core-js-stable/array/is-array");

var _getIteratorMethod = require("@babel/runtime-corejs3/core-js/get-iterator-method");

var _Symbol = require("@babel/runtime-corejs3/core-js-stable/symbol");

var _Array$from = require("@babel/runtime-corejs3/core-js-stable/array/from");

var _sliceInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/slice");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var _layoutGridUtils = require("../../LayoutGrid/_layoutGridUtils");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _Symbol === "undefined" || _getIteratorMethod(o) == null) { if (_Array$isArray2(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = _getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context27; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context27 = Object.prototype.toString.call(o)).call(_context27, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var ANONYMOUS = '<<anonymous>>';
/* eslint-disable no-console */

var arrayOfTupleTypes = function arrayOfTupleTypes(propType) {
  return function (props, propName, componentName) {
    if (!(0, _isArray.default)(props[propName])) {
      var _context;

      return new Error((0, _concat.default)(_context = "Invalid property ".concat(propName, " supplied to ")).call(_context, componentName, " needs to be an array."));
    }

    var _iterator = _createForOfIteratorHelper(props[propName]),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var innerProp = _step.value;

        if (!(0, _isArray.default)(innerProp) || innerProp.length !== 2) {
          var _context2;

          return new Error((0, _concat.default)(_context2 = "Invalid property ".concat(propName, " supplied to ")).call(_context2, componentName, " needs to be an array of arrays with length 2."));
        }

        _propTypes.default.checkPropTypes((0, _defineProperty2.default)({}, "".concat(propName, "[0]"), propType), (0, _defineProperty2.default)({}, "".concat(propName, "[0]"), innerProp[0]), "".concat(propName, "[0]"), componentName);

        _propTypes.default.checkPropTypes((0, _defineProperty2.default)({}, "".concat(propName, "[1]"), propType), (0, _defineProperty2.default)({}, "".concat(propName, "[1]"), innerProp[1]), "".concat(propName, "[1]"), componentName);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return null;
  };
};

var elementOrArrayOfElements = function elementOrArrayOfElements() {
  // Element is not defined unless the Browser API is defined
  if (typeof Element === 'undefined') {
    return _propTypes.default.any;
  }

  return _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.instanceOf(Element)), _propTypes.default.instanceOf(Element)]);
};

var validColumnProp = function validColumnProp(props, propName, componentName) {
  var _context4;

  var spanValue = props === null || props === void 0 ? void 0 : props[propName];
  if (!spanValue) return;

  switch ((0, _typeof2.default)(spanValue)) {
    case 'number':
      if (!(0, _layoutGridUtils.validSpan)(spanValue)) {
        var _context3;

        return new Error((0, _concat.default)(_context3 = "Invalid property ".concat(propName, " supplied to ")).call(_context3, componentName, ". Value should be a number between 1-12 (including)."));
      }

      break;

    case 'object':
      (0, _forEach.default)(_context4 = (0, _keys.default)(_constants.SCREEN_SIZE_MAP)).call(_context4, function (size) {
        var spanForSize = spanValue === null || spanValue === void 0 ? void 0 : spanValue[size];

        if (!(0, _layoutGridUtils.validSpan)(spanForSize)) {
          var _context5, _context6;

          return new Error((0, _concat.default)(_context5 = (0, _concat.default)(_context6 = "Invalid property ".concat(propName, ".")).call(_context6, size, " supplied to ")).call(_context5, componentName, ". Value should be a number between 1-12 (including)."));
        }
      });
      break;

    default:
      break;
  }
};

var wrapValidator = function wrapValidator(validator, typeName) {
  var _context7;

  var typeChecker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  // eslint-disable-next-line compat/compat
  return (0, _assign.default)((0, _bind.default)(validator).call(validator), {
    typeName: typeName,
    typeChecker: typeChecker,
    // eslint-disable-next-line compat/compat
    isRequired: (0, _assign.default)((0, _bind.default)(_context7 = validator.isRequired).call(_context7), {
      typeName: typeName,
      typeChecker: typeChecker,
      typeRequired: true
    })
  });
};

var createChainableTypeChecker = function createChainableTypeChecker(validate) {
  var checkType = function checkType(isRequired, props, propName, componentName, location, propFullName) {
    componentName = componentName || ANONYMOUS;
    propFullName = propFullName || propName;
    var value = props[propName];

    if (typeof value === 'undefined' || value === null) {
      if (isRequired) {
        var _context8, _context9, _context10;

        return new TypeError((0, _concat.default)(_context8 = (0, _concat.default)(_context9 = (0, _concat.default)(_context10 = "The ".concat(location, " `")).call(_context10, propFullName, "` is marked as required in `")).call(_context9, componentName, "`, but its value is `")).call(_context8, value === null ? 'null' : (0, _typeof2.default)(value), "`."));
      }

      return null;
    } else {
      return validate(props, propName, componentName, location, propFullName);
    }
  };

  var chainedCheckType = (0, _bind.default)(checkType).call(checkType, null, false);
  chainedCheckType.isRequired = (0, _bind.default)(checkType).call(checkType, null, true);
  return chainedCheckType;
};

var range = function range(min, max) {
  if (isNaN(min)) {
    console.error('The \`min\` parameter supplied to the \`range\` propType is required and must be a \`number\`.');
    return function () {
      return null;
    };
  }

  if (isNaN(max)) {
    console.error('The \`max\` parameter supplied to the \`range\` propType is required and must be a \`number\`.');
    return function () {
      return null;
    };
  }

  if (min >= max) {
    console.error('In the \`range\` propType, the \`min\` value must be less than the \`max\` value.');
    return function () {
      return null;
    };
  }

  var validate = function validate(props, propName, componentName, location, propFullName) {
    var value = props[propName]; // If no value is provided, don't fail validation.

    if (typeof value === 'undefined' || value === null) {
      return null;
    }

    if (isNaN(value)) {
      var _context11, _context12, _context13;

      return new TypeError((0, _concat.default)(_context11 = (0, _concat.default)(_context12 = (0, _concat.default)(_context13 = "Invalid ".concat(location, " `")).call(_context13, propFullName, "` of type `")).call(_context12, (0, _typeof2.default)(value), "` supplied to `")).call(_context11, componentName, "`, expected `number`."));
    }

    if (value < min || value > max) {
      var _context14, _context15, _context16, _context17, _context18;

      return new Error((0, _concat.default)(_context14 = (0, _concat.default)(_context15 = (0, _concat.default)(_context16 = (0, _concat.default)(_context17 = (0, _concat.default)(_context18 = "The ".concat(location, " `")).call(_context18, propFullName, "` supplied to `")).call(_context17, componentName, "` has a value of `")).call(_context16, value, "`, which is not in the range `")).call(_context15, min, "` to `")).call(_context14, max, "` (inclusive)."));
    }

    return null;
  };

  return wrapValidator(createChainableTypeChecker(validate), 'range', {
    min: min,
    max: max
  });
};

var i18n = function i18n(obj) {
  if (!obj) {
    console.error('The shape parameter supplied to the \`i18n\` propType is required.');
    return function () {
      return null;
    };
  }

  var shapeKeys = (0, _keys.default)(obj);

  var validate = function validate(props, propName, componentName, location, propFullName) {
    var value = props[propName];

    if (!value) {
      var _context19, _context20;

      return new Error((0, _concat.default)(_context19 = (0, _concat.default)(_context20 = "The ".concat(location, " `")).call(_context20, propFullName, "` was not supplied to `")).call(_context19, componentName, "`."));
    }

    var valueKeys = (0, _keys.default)(value);

    if (valueKeys.length !== shapeKeys.length) {
      var _context21, _context22, _context23, _context24, _context25, _context26;

      var missMatchType = '';
      var missMatchKeys = [];

      if (valueKeys.length < shapeKeys.length) {
        missMatchType = 'Missing';
        missMatchKeys = (0, _filter.default)(shapeKeys).call(shapeKeys, function (key) {
          return !(0, _some.default)(valueKeys).call(valueKeys, function (k) {
            return key === k;
          });
        });
      } else {
        missMatchType = 'Extra';
        missMatchKeys = (0, _filter.default)(valueKeys).call(valueKeys, function (key) {
          return !(0, _some.default)(shapeKeys).call(shapeKeys, function (k) {
            return key === k;
          });
        });
      }

      return new Error((0, _concat.default)(_context21 = (0, _concat.default)(_context22 = (0, _concat.default)(_context23 = (0, _concat.default)(_context24 = (0, _concat.default)(_context25 = (0, _concat.default)(_context26 = "The ".concat(location, " `")).call(_context26, propFullName, "` supplied to `")).call(_context25, componentName, "` has ")).call(_context24, valueKeys.length, " string(s) when ")).call(_context23, shapeKeys.length, " were expected. ")).call(_context22, missMatchType, " ")).call(_context21, (0, _map.default)(missMatchKeys).call(missMatchKeys, function (key) {
        return "`".concat(key, "`");
      }).join(', '), "."));
    }

    return null;
  };

  return wrapValidator(createChainableTypeChecker(validate), 'i18n', obj);
};

var _default = {
  arrayOfTupleTypes: arrayOfTupleTypes,
  elementOrArrayOfElements: elementOrArrayOfElements,
  range: range,
  i18n: i18n,
  validColumnProp: validColumnProp
};
exports.default = _default;